module.exports = __webpack_public_path__ + "static/media/img_5.153ca568.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_5.jpg
// module id = 545
// module chunks = 0